import * as $ from "jquery";
import { Helpers } from "../helpers/helpers";
import EventBusService from "../services/EventBusService";
import PopupManager from "../managers/PopupManager";
/**
 * Класс по работе с попапом предупреждения
 */
export default class NoticeSpecializationPopup {
    private COOKIE_NAME: string = 'CONFIRM_SPECIALIZATION_NOTICE_POPUP';
    private SUCCESS_CLASS = 'success';
    private TYPE_POPUP = 'notice-specialisation';

    private readonly $popup: JQuery;
    private popupManager: PopupManager;

    private selectors = {
        popupClass: '.js-notice-popup',
        confirmButton: '.js-notice-confirm',
    }

    constructor(popupManager: PopupManager) {
        this.$popup = $(this.selectors.popupClass);
        this.popupManager = popupManager;

        this.confirmClickHandler = this.confirmClickHandler.bind(this);

        this.init();
    }

    /**
     * Инициализация
     * @private
     */
    private init(): void
    {
        if (this.checkCookie()) {
            return;
        }

        this.popupManager.openPopupByType(this.TYPE_POPUP);

        EventBusService.addEventListener(EventBusService.CLOSE_POPUP, (evt: Event) => {
            if (!evt.detail) {
                return;
            }

            const detail = evt.detail as { type: string | undefined };
            if (detail.type && detail.type === this.TYPE_POPUP) {
                if (this.checkCookie()) {
                    return;
                }
                location.reload();
            }
        })

        $(this.$popup).on('click', this.selectors.confirmButton, this.confirmClickHandler);
    }

    /**
     * Установить куку
     * @private
     */
    private setConfirmCookie(): void
    {
        Helpers.setCookie(this.COOKIE_NAME, '1');
    }

    /**
     * Проверить наличие куки
     * @private
     */
    private checkCookie(): boolean
    {
        return !!Helpers.getCookie(this.COOKIE_NAME);
    }

    /**
     * Обработчик клика подтверждения
     * @private
     */
    private confirmClickHandler(): void
    {
        this.setConfirmCookie();
        this.$popup.addClass(this.SUCCESS_CLASS);
        setTimeout(() => {
            this.popupManager.closeAllPopup();
        }, 5000)
    }
}
